import { onBeforeUnmount, watch, type Ref } from 'vue';

const owners = new Set<symbol>();

/** Keeps the page locked until every open overlay has released it. */
export function useScrollLock(active: Ref<boolean>) {
  const owner = Symbol('overlay');
  const update = (locked: boolean) => {
    if (locked) owners.add(owner);
    else owners.delete(owner);
    document.body.classList.toggle('modal-open', owners.size > 0);
  };
  watch(active, update, { immediate: true });
  onBeforeUnmount(() => update(false));
}
